import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

/**
 * MatterLoader - A loader component for Matter page
 * 
 * Unlike the full-page Loader, this loader:
 * - Only covers part of the page (e.g. document area, table area)
 * - Can be positioned below headers using the `offsetTop` prop
 * - Allows other UI elements (like app header) to remain visible
 * - Can use absolute positioning (relative to parent) or fixed positioning (relative to viewport)
 */
const MatterLoader = ({ message, offsetTop = 0, absolute = false }) => {
  return (
    <div style={{
      position: absolute ? 'absolute' : 'fixed',
      top: absolute ? 0 : offsetTop,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: absolute ? '100%' : 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      zIndex: 15, // Lower than breadcrumb header (zIndex: 20) so breadcrumbs stay visible on top
      pointerEvents: 'auto',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        marginTop: '0px',
      }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#0C53BB' }} spin />} />
        <span style={{
          fontSize: '14px',
          color: '#5A6C87',
          textAlign: 'center',
        }}>
          {message || "Loading WebViewer..."}
        </span>
      </div>
    </div>
  );
};

MatterLoader.propTypes = {
  message: PropTypes.string,
  offsetTop: PropTypes.number,
  absolute: PropTypes.bool,
};

export default MatterLoader;
